import React from 'react';
import {MenuItem, TextField} from "@mui/material";

const ItemBrowserHeaderSimpleSelect = ({label, options, value, setValue, fullWidth = true, sx}) => {
    return (
        <TextField
            select
            fullWidth={fullWidth}
            sx={sx}
            size="small"
            label={label}
            value={value}
            onChange={e => setValue(e.target.value)}
            slotProps={{
                inputLabel: {
                    disableAnimation: true,
                    shrink: true,
                },
                input: {
                    sx: {
                        backgroundColor: "white",
                        borderRadius: "4px"
                    }
                },
            }}
        >
            {options.map(option => <MenuItem key={option.id} value={option.id}>{option.name}</MenuItem>)}
        </TextField>
    );
};

export default ItemBrowserHeaderSimpleSelect;